import{createContext as o}from"../utils/context";export const[CheckboxGroupProvider,useCheckboxGroupContext]=o({name:"CheckboxGroupContext",strict:!1});